import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRule  {
    _originalTypeClassName = "zERP.BO.LeaveRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRule.translate = translateService;
}
this.PayrollVariableAssigments = [];
this.ApprovalFlow = new Domain.ApprovalFlow();
this.Id = null;
this.Name = null;
this.Abbreviation = null;
this.Statutory = false;
this.LawPolicy = null;
this.Notes = null;
this.Entitlement = null;
this.EntitllmentRefreshPeriod = null;
this.AbsenceAccrualEffect = false;
this.ParticipatesInPayroll = false;
this.IsPayable = false;
this.DocumentationIsRequired = false;
this.DocumentationDescription = null;
this.CanBeRequestedByEmployee = false;
this.SubsidyRight = false;
this.TimeUnit = null;
this.BalanceCallendar = null;
this.SubsidyProvider = null;
this.EntitlementOverbalanceHandling = null;
this.InheritEntitlement = false;
this.EntitltmentFillMethod = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Abbreviation:any;
Statutory:any;
LawPolicy:any;
Notes:any;
Entitlement:any;
EntitllmentRefreshPeriod:any;
AbsenceAccrualEffect:any;
ParticipatesInPayroll:any;
IsPayable:any;
DocumentationIsRequired:any;
DocumentationDescription:any;
CanBeRequestedByEmployee:any;
SubsidyRight:any;
TimeUnit:any;
BalanceCallendar:any;
SubsidyProvider:any;
EntitlementOverbalanceHandling:any;
InheritEntitlement:any;
EntitltmentFillMethod:any;
ErganiLeaveType:any;
LeaveType:any;
PayrollVariableAssigments:any;
InheritEntitlementFrom:any;
ApprovalFlow:any;
AcceptanceDocumentTemplate:any;
static setErganiLeaveType = ($this, value) => {
var oldValue = $this.ErganiLeaveType;
$this.ErganiLeaveType = value;
if (value != null) {
}
}
static setLeaveType = ($this, value) => {
var oldValue = $this.LeaveType;
$this.LeaveType = value;
if (value != null) {
}
}
static setPayrollVariableAssigments = ($this, items) => {
                if (items == null) items = [];
                if ($this.PayrollVariableAssigments == null) $this.PayrollVariableAssigments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PayrollVariableAssigments.length > 0) {
                    Domain.LeaveRule.removePayrollVariableAssigments($this, $this.PayrollVariableAssigments[0]);
                }

                Domain.LeaveRule.addManyPayrollVariableAssigments($this, copyItems);
            }
static addManyPayrollVariableAssigments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.LeaveRule.addPayrollVariableAssigments($this, items[i]);
                }
            }
static addPayrollVariableAssigments = ($this, item) => {
                if ($this.PayrollVariableAssigments == null) $this.PayrollVariableAssigments = [];
                if (item == null || $this.PayrollVariableAssigments.indexOf(item) > -1) return;
                $this.PayrollVariableAssigments.push(item);
if (item.LeaveRule != $this) {
Domain.PayrollVariableAssigment.setLeaveRule(item, $this);
}
}
static addRangePayrollVariableAssigments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.LeaveRule.addPayrollVariableAssigments($this, item));
            }
static removePayrollVariableAssigments = ($this, item) => {
                if ($this == null || $this.PayrollVariableAssigments == null || $this.PayrollVariableAssigments.indexOf(item) === -1) return;
                var _index = $this.PayrollVariableAssigments.indexOf(item);
                $this.PayrollVariableAssigments.splice(_index, 1);
item.LeaveRule = null;
}
static clearPayrollVariableAssigments = ($this) => { $this.PayrollVariableAssigments = null; }
static setInheritEntitlementFrom = ($this, value) => {
var oldValue = $this.InheritEntitlementFrom;
$this.InheritEntitlementFrom = value;
if (value != null) {
}
}
static setApprovalFlow = ($this, value) => {
var oldValue = $this.ApprovalFlow;
$this.ApprovalFlow = value;
if (value != null) {
}
}
static setAcceptanceDocumentTemplate = ($this, value) => {
var oldValue = $this.AcceptanceDocumentTemplate;
$this.AcceptanceDocumentTemplate = value;
if (value != null) {
}
}

static Calc(daysOnThisPeriod: any,moreThanThreeDaysCount: any,daysUntilNow: any,bucket2Limit: any): any{if (CLMS.Framework.Number.LessThanOrEqual(() => daysOnThisPeriod, () => 3)) {return [parseFloat((daysOnThisPeriod) as any), 0.0, 0.0];}
let remaining = daysOnThisPeriod;
let bucket1 = 0.0;
let bucket2 = 0.0;
let bucket3 = 0.0;
if (CLMS.Framework.Number.Equal(() => moreThanThreeDaysCount, () => 0)) {bucket1 = 3;remaining = Joove.Common.safeNumber(remaining) - Joove.Common.safeNumber(bucket1);daysUntilNow = Joove.Common.safeNumber(daysUntilNow) + Joove.Common.safeNumber(bucket1);}
if (CLMS.Framework.Number.GreaterThan(() => Joove.Common.safeNumber(daysUntilNow) + Joove.Common.safeNumber(remaining), () => bucket2Limit)) {bucket2 = Joove.Common.safeNumber(bucket2Limit) - Joove.Common.safeNumber((Joove.Common.safeNumber(daysUntilNow) + Joove.Common.safeNumber(remaining)));remaining = Joove.Common.safeNumber(remaining) - Joove.Common.safeNumber(bucket2);daysUntilNow = Joove.Common.safeNumber(daysUntilNow) + Joove.Common.safeNumber(bucket2);}else {bucket2 = remaining;remaining = 0;}
if (CLMS.Framework.Number.GreaterThan(() => remaining, () => 0)) {bucket3 = remaining;}
console.info(CLMS.Framework.String.Format("bucket1: {0}, bucket2: {1}, bucket3: {2}", bucket1, bucket2, bucket3));
return [bucket1, bucket2, bucket3];
}
static CalculateNormalLeaveRight(year: any,contract: any,leavesExperience: any): any{let yearInEmployment = Domain.EmployeeContract.GetWorkExperienceInYears(contract, false);
let factor = 0;
if (CLMS.Framework.Number.GreaterThanOrEqual(() => (Joove.Common.safeNumber(leavesExperience.ExperienceInYears) + Joove.Common.safeNumber(yearInEmployment)), () => 12)) {factor = 25;}else if (CLMS.Framework.Number.Equal(() => yearInEmployment, () => 0)) {factor = 20;}else if (CLMS.Framework.Number.Equal(() => yearInEmployment, () => 1) || CLMS.Framework.Number.Equal(() => yearInEmployment, () => 2)) {factor = 21;}else if (CLMS.Framework.Number.LessThan(() => yearInEmployment, () => 10)) {factor = 22;}else {factor = 25;}
let firstDayOfYear = moment([moment(moment().toDate()).year(), (1) - 1, 1]).toDate();
if ((new Date(contract?.StartDate).getTime()) <= (new Date(firstDayOfYear).getTime())) {return factor;}
let monthFactor = Joove.Common.safeNumber((parseFloat((factor) as any))) / Joove.Common.safeNumber(12);
let total = 0;
for (var i = 1; CLMS.Framework.Number.LessThan(() => i, () => 13); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
if (CLMS.Framework.Number.GreaterThan(() => (moment(contract.StartDate).month() + 1), () => i)) {continue;}else if (CLMS.Framework.Number.Equal(() => (moment(contract.StartDate).month() + 1), () => i)) {let daysInMonth = parseFloat((moment("moment(contract?.StartDate).year()-(moment(contract?.StartDate).month()+1)", "YYYY-MM").daysInMonth()) as any);let remainingDays = Joove.Common.safeNumber(daysInMonth) - Joove.Common.safeNumber(moment(contract?.StartDate).date());total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber((Joove.Common.safeNumber((Joove.Common.safeNumber(remainingDays) / Joove.Common.safeNumber(daysInMonth))) * Joove.Common.safeNumber(monthFactor)));}else {total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber(monthFactor);}}

return parseInt((Joove.Common.mathRound(total, 0, Joove.MidpointRounding.AwayFromZero)) as any);
}
static CalculateRight($this: any, year: any,contract: any): any{if ($this?.EntitltmentFillMethod == Domain.RuleEntitlementMethod.NormalLeave) {return Domain.LeaveRule.CalculateNormalLeaveRight(year, contract, contract?.Employee?.DayOffExperienceAnalysis);}else if ($this?.EntitltmentFillMethod == Domain.RuleEntitlementMethod.Illness) {return Domain.LeaveRule.CalculateSiknessLeaveRight(year, contract);}
return $this?.Entitlement;
}
static CalculateSiknessLeaveRight(year: any,contract: any): any{let yearInEmployment = Domain.EmployeeContract.GetWorkExperienceInYears(contract, false);
if (CLMS.Framework.Number.LessThan(() => yearInEmployment, () => 1)) {return 15;}
return 30;
}
static CopyEntitlementData(from: any,to: any): any{to.EntitltmentFillMethod = from?.EntitltmentFillMethod;
to.Entitlement = from?.Entitlement;
to.TimeUnit = from?.TimeUnit;
to.AbsenceAccrualEffect = from?.AbsenceAccrualEffect;
to.EntitllmentRefreshPeriod = from?.EntitllmentRefreshPeriod;
to.EntitlementOverbalanceHandling = from?.EntitlementOverbalanceHandling;
to.BalanceCallendar = from?.BalanceCallendar;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}